// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbooksQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type WorkbooksQuery = {
  __typename?: "GraphqlQuery";
  getWorkbooks: Array<{
    __typename?: "Workbook";
    id: string;
    name: string;
    description?: string | null;
    createdAt: number;
    lastActivityAt: number;
    variantsCount: number;
    draft: boolean;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
    database: { __typename?: "Database"; id: string; datname?: string | null };
  }>;
};

export const WorkbooksDocument = gql`
  query Workbooks($databaseId: ID!) {
    getWorkbooks(databaseId: $databaseId) {
      id
      name
      description
      createdAt
      lastActivityAt
      variantsCount
      draft
      user {
        id
        fullname
      }
      server {
        id
        humanId
        name
      }
      database {
        id
        datname
      }
    }
  }
`;

/**
 * __useWorkbooksQuery__
 *
 * To run a query within a React component, call `useWorkbooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbooksQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useWorkbooksQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbooksQuery,
    WorkbooksQueryVariables
  > &
    (
      | { variables: WorkbooksQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkbooksQuery, WorkbooksQueryVariables>(
    WorkbooksDocument,
    options,
  );
}
export function useWorkbooksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbooksQuery,
    WorkbooksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkbooksQuery, WorkbooksQueryVariables>(
    WorkbooksDocument,
    options,
  );
}
// @ts-ignore
export function useWorkbooksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbooksQuery,
    WorkbooksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<WorkbooksQuery, WorkbooksQueryVariables>;
export function useWorkbooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkbooksQuery, WorkbooksQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  WorkbooksQuery | undefined,
  WorkbooksQueryVariables
>;
export function useWorkbooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkbooksQuery, WorkbooksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkbooksQuery, WorkbooksQueryVariables>(
    WorkbooksDocument,
    options,
  );
}
export type WorkbooksQueryHookResult = ReturnType<typeof useWorkbooksQuery>;
export type WorkbooksLazyQueryHookResult = ReturnType<
  typeof useWorkbooksLazyQuery
>;
export type WorkbooksSuspenseQueryHookResult = ReturnType<
  typeof useWorkbooksSuspenseQuery
>;
export type WorkbooksQueryResult = Apollo.QueryResult<
  WorkbooksQuery,
  WorkbooksQueryVariables
>;
